<template>
  <div class="detail-page">
<!--    <div class="detail-page__left"-->
<!--         v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">-->
<!--      <div class="admin-edit" @click="editTranslate(['heartysan_price'])"></div>-->
<!--      <CardLeftBlock-->
<!--          :name="''"-->
<!--          :value="HL.data.name"-->
<!--          :backgroundImage="'product-admin'"-->
<!--          class="cus-payments"-->
<!--      >-->
<!--&lt;!&ndash;        <template slot="body">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="card-detail-left__date mt-1">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--        <template slot="button">-->
<!--          <h2 class="mt-0">{{$t('heartysan_price.localization_value.value')}} : ${{HL.data.price}}</h2>-->
<!--        </template>-->
<!--      </CardLeftBlock>-->
<!--    </div>-->

    <div class="detail-page__right">
      <CardRightBlock>
        <template slot="header">
          <div class="order-create__head mb-3">
            <div class="order-create__head-line">
              <div class="order-create__header-col"
                   v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['heartysan_backTo'])"></div>
                <router-link :to="$store.getters.GET_PATHS.heartysanManufacturerListings" class="detail-page__head-back">
                  <LinkBack
                      :value="$t('heartysan_backTo.localization_value.value')"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </template>

        <template slot="body">
          <ListingShowBlock
              :manufacturer="true"
              :HL="HL"
              :loadedImage="loadedImage"
          />
        </template>
        <template slot="footer">
          <div class="order-create__footer">
            <div class="order-create__footer-link"
                 v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_cancel'])"></div>
              <router-link :to="$store.getters.GET_PATHS.heartysanManufacturerListings"
                           class="site-link site-link--alt"
              >
                {{ $t('common_cancel.localization_value.value') }}
              </router-link>

            </div>
          </div>
        </template>
      </CardRightBlock>

    </div>

  </div>
</template>

<script>
// import CardLeftBlock from "../../../../../../../components/coreComponents/CardLeftBlock/CardLeftBlock.vue";
import CardRightBlock from "../../../../../../coreComponents/CardRightBlock/CardRightBlock.vue";
import LinkBack from "../../../../../../UI/buttons/LinkBack/LinkBack.vue";
import {mixinDetictingMobile} from "@/mixins/mobileFunctions";
import ListingShowBlock from "@/components/modules/HeartysanModule/components/chunks/ListingShowBlock/ListingShowBlock";


export default {
  name: "HeartysanManufacturerListingShowUser",

  components: {
    ListingShowBlock,
    // CardLeftBlock,
    CardRightBlock,
    LinkBack,
  },

  mixins: [mixinDetictingMobile],

  props: {
    HL: Object,
    loadedImage: Boolean,
  },

  data() {
    return {}
  },

  methods: {}
}
</script>

<style scoped>

/*@media (min-width: 1600px) {*/
/*  .detail-page__right{*/
/*    max-width: 70%;*/
/*  }*/
/*}*/
</style>

